import { Injectable } from '@angular/core';

import { MailFeedModel } from '../../../shared/models/mail';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind, SlideLayout, SlideTimingKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class MailContentProvider implements ContentProvider<MailFeedModel> {
  public readonly kind = ContentKind.Mail;
  public readonly tier = RefreshTier.Secondary;
  public readonly order = 90;
  public readonly presentation = PresentationSlot.Overlay;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public async fetch(context: FetchContextModel): Promise<MailFeedModel[]> {
    const mail = await context.source.loadMail(context.signal);

    return mail ? [mail] : [];
  }

  public toSlides(items: MailFeedModel[]): RuntimeSlideModel[] {
    return items.map((mail): RuntimeSlideModel => ({
      id: 'mail:0:overlay', kind: this.kind, layout: SlideLayout.Backdrop, content: { id: 0, providerChannelIds: [], mail },
      duration: { kind: SlideTimingKind.Fixed, milliseconds: 20000 }, meta: { sourceId: 0 }
    }));
  }
}
